import { FC, useEffect, useMemo, useRef, useState } from 'react';
import ReactHlsPlayer from 'react-hls-player';

import { Button, Modal, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { Exercises } from 'modules/dashboard/core/type';

import { VideoModal } from '../styles/video-modal';

import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as NextIcon } from 'assets/icons/next.svg';

import { getWidthAndHeightVideo } from 'helpers';
import { get, isEmpty } from 'lodash';

export const SupervisedVideo: FC<{
  data: {
    exercise: Exercises;
    video: string;
    videoHeight: string;
    videoWidth: string;
    name: string;
  }[];
  index: number;
  handleCloseModal: () => void;
}> = ({ data, index, handleCloseModal }) => {
  const playerRef = useRef<HTMLVideoElement>(null);

  const videos = useMemo(
    () =>
      data.map((el) => {
        const video = get(el, 'exercise.video', el.video);
        const height = get(el, 'exercise.videoHeight', el.videoHeight);
        const width = get(el, 'exercise.videoWidth', el.videoWidth);
        const name = get(el, 'exercise.name', el.name);

        return {
          video,
          height,
          width,
          name,
        };
      }),
    [data],
  );

  const [currentIndex, setCurrentIndex] = useState(index);

  useEffect(() => {
    setCurrentIndex(index);
  }, [index]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const handleBack = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + videos.length) % videos.length);
  };

  const handleVideoEnded = () => {
    handleNext(); // Automatically play next video when current one ends
  };

  if (isEmpty(videos)) {
    return <></>;
  }

  const style = getWidthAndHeightVideo(
    Number(videos[currentIndex].height) > Number(videos[currentIndex].width) ? 455 : 736,
    Number(videos[currentIndex].width ?? 400),
    Number(videos[currentIndex].height ?? 400),
  );

  return (
    <VideoModal width={Number(style.width)} height={Number(style.height) + 40}>
      <Modal
        modalKey={MODAL_KEY.SHOW_VIDEO}
        hideCloseIcon={true}
        closeOnClickOutside={false}
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography style={{ fontSize: 20, fontWeight: 500, lineHeight: '28px' }}>
              {currentIndex + 1}. {videos[currentIndex].name}
            </Typography>

            <div
              onClick={() => {
                handleCloseModal();
                setCurrentIndex(0);
              }}
              style={{ cursor: 'pointer' }}
            >
              <CloseIcon />
            </div>
          </div>
        }
        footer={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: videos[currentIndex].width,
              maxWidth: Number(style.width) + 48,
              gap: 12,
              padding: 24,
            }}
          >
            {currentIndex === 0 ? (
              <div style={{ width: '50%' }}></div>
            ) : (
              <Button
                placementIcon="left"
                icon={<BackIcon />}
                onClick={handleBack}
                style={{ width: '50%' }}
              >
                Back
              </Button>
            )}
            {currentIndex === videos.length - 1 ? (
              <div style={{ width: '50%' }}></div>
            ) : (
              <Button
                placementIcon="left"
                icon={<NextIcon />}
                onClick={handleNext}
                style={{ width: '50%' }}
              >
                Next
              </Button>
            )}
          </div>
        }
      >
        <div style={{ margin: 'auto' }}>
          {videos[currentIndex].video?.includes('.m3u8') ? (
            <ReactHlsPlayer
              src={videos[currentIndex].video as string}
              autoPlay={true}
              controls={true}
              playerRef={playerRef}
              style={{ maxWidth: 800, maxHeight: 800 }}
              onEnded={handleVideoEnded}
              height={style.height}
              width={style.width}
            />
          ) : (
            <video
              src={videos[currentIndex].video}
              controls
              style={{ maxWidth: 800, maxHeight: 800, height: style.height, width: style.width }}
              autoPlay
              onEnded={handleVideoEnded}
            />
          )}
        </div>
      </Modal>
    </VideoModal>
  );
};
